import CloseIcon from "@/assets/common/ic_modal_close.svg?react";
import ArrowLeftIcon from "@/assets/common/ic_modal_arrow_left.svg?react";
import { QRCodeCanvas } from "@rc-component/qrcode";
import LoadingIcon from "@/assets/common/ic_loading_blue.png";

interface QrCodePanelProps {
  shareUrl?: string;
  onClose: () => void;
  onBack: () => void;
}

const QrCodePanel = ({ shareUrl, onClose, onBack }: QrCodePanelProps) => {
  return (
    <div className="mx-4">
      <div className="flex items-center h-12 w-full">
        <div className="flex items-center">
          <ArrowLeftIcon className="cursor-pointer" onClick={onBack} />
          <div className="text-4 font-500 text-mx-secondary">扫码分享</div>
        </div>
        <CloseIcon
          className="block absolute right-3 top-3 size-6 cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div className="mt-20.5 flex flex-col justify-center items-center mb-6">
        {shareUrl ? (
          <QRCodeCanvas size={160} className="bg-gray" value={shareUrl} />
        ) : (
          <div className="size-40 flex items-center justify-center">
            <img src={LoadingIcon} className="size-6 animate-spin" />
          </div>
        )}
      </div>
      <div className="text-3.5 text-mx-tertiary text-center">- 扫码分享文档 -</div>
    </div>
  );
};

export default QrCodePanel;
